// removed by extract-text-webpack-plugin
module.exports = {"avatar":"hq_fm","largeAvatar":"hq_hr hq_fm","mediumAvatar":"hq_hs hq_fm","smallAvatar":"hq_ht hq_fm","image":"hq_l","largeImage":"hq_hu hq_l","mediumImage":"hq_hv hq_l","smallImage":"hq_hw hq_l","staffBadge":"hq_hx","largeBadge":"hq_hy hq_hx","mediumBadge":"hq_hz hq_hx","smallBadge":"hq_h0 hq_hx"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Avatar/styles.module.css
// module id = 1076
// module chunks = 27